import { IDocumentService, IQService, IRootScopeService, IServiceProvider, IWindowService } from 'angular';
import { GmcRecaptchaService } from './gmc-recaptcha.service';

export class GmcRecaptchaProvider implements IServiceProvider {
  private config: ReCaptchaV2.Parameters = {
    sitekey: '6Lef4EEUAAAAAJXJ6pwx4sn6lmaHtRaZ-2vLTo-u'
  };
  private onLoadFunctionName = 'gmcRecaptchaLoaded';

  constructor() {
    this.$get.$inject = [
      '$window',
      '$document',
      '$q',
      '$rootScope'
    ];
  }

  setConfig( config: ReCaptchaV2.Parameters ) {
    this.config = { ...config };
  }

  $get( $window: IWindowService,
        $document: IDocumentService,
        $q: IQService,
        $rootScope: IRootScopeService ) {
    const service = new GmcRecaptchaService($window, $document, $q, $rootScope);
    service.config = this.config;
    service.onLoadFunctionName = this.onLoadFunctionName;
    return service;
  }
}



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-recaptcha/gmc-recaptcha.provider.ts